import { render, staticRenderFns } from "./CollectPaymentModal.vue?vue&type=template&id=2593bf22&scoped=true"
import script from "./CollectPaymentModal.vue?vue&type=script&lang=js"
export * from "./CollectPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./CollectPaymentModal.vue?vue&type=style&index=0&id=2593bf22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593bf22",
  null
  
)

export default component.exports